import { render, staticRenderFns } from "./ChatInputAudio.vue?vue&type=template&id=8a520aa0&scoped=true&"
import script from "./ChatInputAudio.vue?vue&type=script&lang=js&"
export * from "./ChatInputAudio.vue?vue&type=script&lang=js&"
import style0 from "./ChatInputAudio.vue?vue&type=style&index=0&id=8a520aa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a520aa0",
  null
  
)

export default component.exports